module.exports = __webpack_public_path__ + "img/icon91.53a0baed.png";